import type { FC, SVGProps } from "react";

const IconFilter: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M9.66699 12.167H2.16699" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.833 3.83301H6.33301" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.167 14.667C13.5477 14.667 14.667 13.5477 14.667 12.167C14.667 10.7863 13.5477 9.66699 12.167 9.66699C10.7863 9.66699 9.66699 10.7863 9.66699 12.167C9.66699 13.5477 10.7863 14.667 12.167 14.667Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.83301 6.33301C5.21372 6.33301 6.33301 5.21372 6.33301 3.83301C6.33301 2.4523 5.21372 1.33301 3.83301 1.33301C2.4523 1.33301 1.33301 2.4523 1.33301 3.83301C1.33301 5.21372 2.4523 6.33301 3.83301 6.33301Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFilter;
